import { render, staticRenderFns } from "./MidwifeActivityDetail.vue?vue&type=template&id=b76defb4"
import script from "./MidwifeActivityDetail.vue?vue&type=script&lang=js"
export * from "./MidwifeActivityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports